'use strict';

require('../core/core');
require('../../modules/forms/forms');
require('../../modules/maps/maps');

require('../../models/project/project');
require('../../models/project/projectReport');
require('../../models/project/projectUserType');

require('../../forms/projectReportForm');
require('../../forms/eventProjectRequestForm');

require('../../helpers/show-modal-message/show-modal-message');
require('../../helpers/users/users.module');

require('../fos_user/directives/unique-user');

require('../../modals/mountain-route-form/mountain-route-form');
require('../../modals/slider/slider');

require('../documents/documents.module');

angular.module('far.project', [
    'ngTouch',
    'dndLists',
    'ngMessages',
    'angularFileUpload',
    'ui.select',
    'ui.bootstrap',
    'dekky.forms',
    'far.models.project.project',
    'far.models.project.projectReport',
    'far.models.project.projectUserType',
    'far.core',
    'far.maps',
    'far.forms.projectReportForm',
    'far.forms.eventProjectRequestForm',
    'templates',
    'far.helpers.showModalMessage',
    'far.helpers.users',
    'far.fos_user.uniqueUser',
    'far.modals.slider',
    'far.documents.search'
]).value('formsConfig', {
    theme: '/dekky.forms/themes/far'
}).run(function ($templateCache) {
    $templateCache.put('/far.project/fields/partnersCollection.html',
        '<div ng-init="model = model || []" ng-model="model">' +
        '<div repeat-collection ng-init="fieldIndex = $index" ng-form="childForm">' +
        '<div class="form-group right">' +
        '<button class="btn-gold" type="button" ng-click="field.doDelete(item, model, $index)">{{ field.buttons.remove }}</button>' +
        '</div>' +
        '<form-row ng-model="item.name" field="field.childForm.$fields.name" field-index="fieldIndex"></form-row>' +
        '<p class="form__error" role="alert" ng-if="childForm.$$parentForm.$submitted && childForm.name.$error.required">Обязательное поле</p>' +
        '<form-row ng-model="item.url" field="field.childForm.$fields.url" field-index="fieldIndex"></form-row>' +
        '<p class="form__error" role="alert" ng-if="childForm.$$parentForm.$submitted" ng-messages="childForm.url.$error">' +
        '<span ng-message="required">Обязательное поле</span>' +
        '<span ng-message="url">Урл в неверном формате</span>' +
        '</p>' +
        '<form-row ng-model="item.logo" field="field.childForm.$fields.logo" field-index="fieldIndex"></form-row>' +
        '<div class="form__line"></div>' +
        '</div>' +

        '<div class="form-group">' +
        '<button class="btn-standart" type="button" ng-click="field.addItem(model)">{{ field.buttons.add }}</button>' +
        '</div>' +
        '</div>'
    );
});
